/**
 * Inline wallet mark used for in-app brand chrome (header, login, loading shell).
 * Renders ONLY the inner wallet artwork (white, folded-flap wallet + clasp dot)
 * on a transparent background — it is meant to sit inside an existing blue box
 * (e.g. `bg-blue-500 rounded-lg`), so it must not draw its own frame/background.
 */
export function BrandLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      aria-hidden="true"
    >
      <g fill="#ffffff">
        <path d="M26.621 8.794h-1.573V5.678c0-1.032-.462-1.995-1.269-2.64s-1.844-.886-2.852-.658L4.638 6.038A3.36 3.36 0 0 0 2 9.335v16.99a3.383 3.383 0 0 0 3.379 3.379h21.242A3.383 3.383 0 0 0 30 26.325V12.174a3.384 3.384 0 0 0-3.379-3.38zM28 26.325a1.38 1.38 0 0 1-1.379 1.379H5.379A1.38 1.38 0 0 1 4 26.325V9.335c0-.65.442-1.203 1.076-1.346l16.29-3.658c.406-.093.834.005 1.164.269.329.263.518.656.518 1.078v3.117H7.952a1 1 0 1 0 0 2h18.669A1.38 1.38 0 0 1 28 12.174z" />
        <path d="M23.893 17.721c-.884 0-1.604.719-1.604 1.604s.72 1.604 1.604 1.604 1.604-.719 1.604-1.604-.721-1.604-1.604-1.604z" />
      </g>
    </svg>
  );
}
